import './Styles/global.css';
import 'rc-calendar/dist/rc-calendar.css';

import { UserManager } from 'oidc-client';
import React from 'react';
import { render } from 'react-dom';
import { RouteComponentProps } from 'react-router-dom';
import {
    ApplicationConfiguration,
    configureAuthorisation,
    createUserManagerSettings
} from './Config/ApplicationConfig';
import { ApplicationAuthentication } from './AppShell/Authentication/ApplicationAuthentication';
import { ApplicationRoot } from './AppShell/Authentication/ApplicationRoot';
import { LayoutCentral } from './Components/Layout/LayoutCentral';
import { LoadingPlaceholder } from './Components/Placeholder';
import { ServicesAustraliaFeature } from './ServicesAustraliaFeature';
import * as serviceWorker from './serviceWorker';
import { ServicesAustraliaPermissions } from './ServicesAustraliaPermissions';
import { PermissionsCheck } from './Components/Auth/PermissionsCheck';
import { LoadingError } from './Components/SplashScreens/LoadingError';

async function loadFont(fontName: string, woffUrl: string) {
    const localStoragePrefix = 'local-font-' + fontName;
    const localStorageUrlKey = localStoragePrefix + 'url';
    const localStorageCssKey = localStoragePrefix + 'css';
    const storedFontUrl = localStorage.getItem(localStorageUrlKey);
    const storedFontCss = localStorage.getItem(localStorageCssKey);
    const styleElement: HTMLStyleElement = document.createElement('style');
    document.head.appendChild(styleElement);

    if (storedFontCss && storedFontUrl === woffUrl) {
        styleElement.textContent = storedFontCss;
    } else {
        const url = woffUrl;

        const fontCss = await fetch(woffUrl).then(response => response.text());
        localStorage.setItem(localStorageUrlKey, url);
        styleElement.textContent = fontCss;
        localStorage.setItem(localStorageCssKey, fontCss);
    }
}

loadFont('sourceSansPro', '/fonts.woff.css');

const PermissionsWrappedSettingsFeature = (props: RouteComponentProps): React.ReactElement => (
    <PermissionsCheck
        permission={[ServicesAustraliaPermissions.AdministrationGeneral]}
        alternate={
            <LayoutCentral>
                <LoadingError
                    message='You don’t have permissions to view this page'
                    info={
                        <>
                            <div>Please contact your system administrator to resolve the issue.</div>
                            <div>Please refresh your page to try again.</div>
                        </>
                    }
                />
            </LayoutCentral>
        }
    >
        <ServicesAustraliaFeature {...props} />
    </PermissionsCheck>
);

async function boot() {
    let appConfig: ApplicationConfiguration;
    try {
        appConfig = await fetch('/configuration.json').then(response => response.json());
    } catch (err) {
        if (err instanceof Error) {
            throw new Error(`Unable/Parse config file: ${err.message}`);
        }

        throw err;
    }

    const userManager = new UserManager(createUserManagerSettings(appConfig));

    configureAuthorisation({
        appConfig,
        userManager
    });

    render(
        <ApplicationAuthentication manager={userManager}>
            <ApplicationRoot
                root={PermissionsWrappedSettingsFeature}
                loadingSpinner={
                    <LayoutCentral>
                        <LoadingPlaceholder />
                    </LayoutCentral>
                }
            />
        </ApplicationAuthentication>,
        document.getElementById('root')
    );
}

boot();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
